module.exports = __webpack_public_path__ + "static/media/social-icon-x-red.7de1da18.svg";